export default __webpack_public_path__ + "static/media/Virtual Conference.ab7184a6.jpg";